import r from "./index119.mjs";
function m(o) {
  return r().startOf("day").seconds(o).format("m:ss");
}
export {
  m as formatTime
};
